module.exports = __webpack_public_path__ + "static/media/women.a391f61b.webp";